import React, { memo } from 'react';
import { Tabs } from '@mui/material';

import {
  ListMinifiedIcon,
  ListExpandedIcon,
  TraysIcon,
  ChartIcon,
} from '../../../icons';
import StyledTab from '../../../IconTab';
import ListAddItemButton from './ListAddItemButton';
import { RouteListTabs } from '../../../../enums/RouteListTabs';

const DrawerToggle = ({
  value,
  onChange,
  onListAddItemClick,
  isRouteDetail,
}) => (
  <Tabs
    TabIndicatorProps={{
      hidden: true,
    }}
    value={value}
    onChange={onChange}
    variant="fullWidth"
  >
    <StyledTab
      icon={<TraysIcon />}
      value={RouteListTabs.defRoutes}
      hidden={isRouteDetail}
      data-testid="trays"
    />
    <StyledTab
      icon={<ListMinifiedIcon />}
      value={RouteListTabs.compact}
      hidden={isRouteDetail}
      data-testid="list-minified"
    />
    <StyledTab
      icon={<ListExpandedIcon />}
      value={RouteListTabs.detailed}
      data-testid="list-expanded"
    />
    <StyledTab
      icon={<ChartIcon />}
      value={RouteListTabs.stats}
      data-testid="chart"
    />
    <ListAddItemButton onClick={onListAddItemClick} />
  </Tabs>
);

export default memo(DrawerToggle);
